export default __webpack_public_path__ + "static/media/ic_seach.11da44a0.svg";